module.exports = global.config = {
    backend: "https://apcliente.appscachacavillaouro.com.br" //villaouro
    //backend: "http://localhost:8082"
    
};